import React from 'react'
import { Form, Row, Col } from 'react-bootstrap'

const RequirementValue = ({
    value = '',
    onChange = () => {},
}) => {

    return (
        <Row style={{ paddingBottom: '10px'}}>
            <Col xs={{ span: 10, offset: 1 }}>
                <Form.Control
                    placeholder='optional'
                    type='text'
                    value={value}
                    onChange={e => onChange(e.target.value)}
                />
            </Col>
        </Row>
    )
}

export default RequirementValue
